import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import moment from "moment";
import { Navigate } from "react-router-dom";

import {
  fetchVendors,
  fetchVendorsSuccess,
  fetchVendorsFailure,
  createInvoice,
  createInvoiceSuccess,
  createInvoiceFailure,
} from "../../store/invoices/actions";
import {
  fetchPurchaseOrderDetail,
  fetchPurchaseOrderDetailSuccess,
  fetchPurchaseOrderDetailFailure,
} from "../../store/purchaseOrders/actions";

import { associatePurchaseOrderInvoice } from "../../store/purchaseOrders/api";

import Alert from "../../utils/Alert";

import Receive from "../../components/invoices/Receive";
import Spinner from "../../components/generics/Spinner";
import { withRouter } from "utils/WithRouter";

export class ReceiveContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invoiceNumber: "",
      totalAmount: "",
      vendor: -1,
      vendorName: "",
      vendorDaysForPayment: null,
      dueDate: "",
      invoiceDate: null,
      submitting: false,
      errors: [],
      isPurchaseOrder: this.props.match.path.includes("purchase_orders"),
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.isPurchaseOrder) this.props.fetchPurchaseOrderDetail(this.props.match.params.id);

    if (!this.state.isPurchaseOrder && this.props.vendorsList.vendors.length === 0) {
      this.props.fetchVendors(this.props);
    }
  }

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if (index !== -1) {
      errors.splice(index, 1);
    }
    return errors;
  };

  handleNumberChange = (event) => {
    var errors = this.spliceError("invoiceNumber");
    this.setState({ invoiceNumber: event.target.value, errors });
  };

  handleVendorChange = (event) => {
    if (event.target.value > -1) {
      var vendor = this.props.vendorsList.vendors.results[event.target.value];
      var errors = this.spliceError("vendor");
      this.setState({
        vendor: vendor.id,
        vendorName: vendor.name,
        errors,
        vendorDaysForPayment: vendor.days_for_payment,
      });
    } else {
      this.setState({ vendor: -1, vendorName: "" });
    }
  };

  handleAmountChange = (event) => {
    var errors = this.spliceError("totalAmount");
    const totalAmount = event.target.value <= 0 ? null : event.target.value;
    this.setState({ totalAmount, errors });
  };

  handleDueDateChange = (event) => {
    let errors = this.spliceError("dueDate");
    let dueDate = event.target.value
      ? moment().format("YYYY-MM-DD") <= moment(event.target.value).format("YYYY-MM-DD")
        ? moment(event.target.value).format("YYYY-MM-DD")
        : null
      : null;
    this.setState({ dueDate, errors });
  };

  handleInvoiceDateChange = (event) => {
    const { purchaseOrder } = this.props;
    let dueDate = "";
    let errors = this.spliceError("invoiceDate");
    let invoiceDate = event.target.value
      ? moment().format("YYYY-MM-DD") >= moment(event.target.value).format("YYYY-MM-DD")
        ? moment(event.target.value).format("YYYY-MM-DD")
        : null
      : null;

    if (
      invoiceDate &&
      ((purchaseOrder.purchaseOrder && purchaseOrder.purchaseOrder.vendor && purchaseOrder.purchaseOrder.vendor.days_for_payment) ||
        this.state.vendorDaysForPayment !== null)
    ) {
      const days = this.state.isPurchaseOrder ? purchaseOrder.purchaseOrder.vendor.days_for_payment : this.state.vendorDaysForPayment;
      dueDate = moment(invoiceDate).add(days, "d").format("YYYY-MM-DD");
      this.setState({ dueDate });
    }
    this.setState({ invoiceDate, errors });
  };

  submitInvoice = () => {
    this.setState({ submitting: true });
    var data = new FormData();
    const isPurchaseOrder = this.state.isPurchaseOrder;
    const vendor = isPurchaseOrder ? this.props.purchaseOrder.purchaseOrder.vendor.id : this.state.vendor;
    if (
      this.state.totalAmount > 0 &&
      this.state.invoiceNumber !== "" &&
      this.state.totalAmount !== "" &&
      vendor !== -1 &&
      this.state.dueDate &&
      this.state.invoiceDate
    ) {
      data.append("invoice_number", this.state.invoiceNumber);
      data.append("total_amount", this.state.totalAmount);
      data.append("vendor", vendor);
      data.append("due_date", this.state.dueDate);
      data.append("invoice_date", this.state.invoiceDate);
      this.props.createInvoice(data, this.props, isPurchaseOrder, this.alertRef);
    } else {
      let errors = this.state.errors.slice();
      if (this.state.invoiceNumber === "") {
        if (errors.indexOf("invoiceNumber") === -1) {
          errors.push("invoiceNumber");
        }
      }
      if (!this.state.totalAmount || this.state.totalAmount <= 0) {
        if (errors.indexOf("totalAmount") === -1) {
          errors.push("totalAmount");
        }
        this.alertRef.current.sendAlert("Total amount must be greater than 0");
      }
      if (vendor === -1) {
        if (errors.indexOf("vendor") === -1) {
          errors.push("vendor");
        }
      }
      if (!this.state.dueDate) {
        if (errors.indexOf("dueDate") === -1) {
          errors.push("dueDate");
        }
        this.alertRef.current.sendAlert("Due date must be greater than today's");
      }
      if (!this.state.invoiceDate) {
        if (errors.indexOf("invoiceDate") === -1) {
          errors.push("invoiceDate");
        }
        this.alertRef.current.sendAlert("Invoice date must not be greater than today	's");
      }
      this.setState({ submitting: false, errors }, () => {
        this.alertRef.current.sendAlert("Please, choose a value for each field.");
      });
    }
  };

  cancelInvoice = () => {
    if (this.state.isPurchaseOrder) this.props.history.push(`/purchase_orders/${this.props.match.params.id}`);
    else this.props.history.push("/invoice/");
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (this.state.isPurchaseOrder) {
      const { purchaseOrder, loading, error } = this.props.purchaseOrder;
      if (!purchaseOrder && !loading && error) {
        return <Navigate to="/purchase_orders" />;
      }

      if (!purchaseOrder) {
        return (
          <div>
            <Alert ref={this.alertRef} />
            <Spinner />
          </div>
        );
      }

      return (
        <Fragment>
          <Alert ref={this.alertRef} />
          <Receive
            isPurchaseOrder
            purchaseOrder={purchaseOrder.id}
            vendor={purchaseOrder.vendor.name}
            dueDate={this.state.dueDate}
            onNumberChange={this.handleNumberChange}
            onAmountChange={this.handleAmountChange}
            onDueDateChange={this.handleDueDateChange}
            onInvoiceDateChange={this.handleInvoiceDateChange}
            submitInvoice={this.submitInvoice}
            cancelInvoice={this.cancelInvoice}
            errors={this.state.errors}
          />
        </Fragment>
      );
    } else {
      if (this.props.vendorsList.loading) {
        return (
          <div>
            <Alert ref={this.alertRef} />
            <Spinner />
          </div>
        );
      }
      return (
        <Fragment>
          <Alert ref={this.alertRef} />
          <Receive
            vendors={this.props.vendorsList.vendors.results}
            onNumberChange={this.handleNumberChange}
            dueDate={this.state.dueDate}
            onVendorChange={this.handleVendorChange}
            onAmountChange={this.handleAmountChange}
            onDueDateChange={this.handleDueDateChange}
            onInvoiceDateChange={this.handleInvoiceDateChange}
            submitInvoice={this.submitInvoice}
            cancelInvoice={this.cancelInvoice}
            errors={this.state.errors}
          />
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    purchaseOrder: state.purchaseOrders.purchaseOrderDetail,
    vendorsList: state.invoices.vendorsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (data, props) => {
    props.history.push("/invoice/" + data.id);
  };
  const associateInvoice = (purchaseOrderId, invoice, props, alertRef) => {
    associatePurchaseOrderInvoice(purchaseOrderId, { invoice: invoice.invoice_number })
      .then((response) => {
        props.history.push(`/purchase_orders/${purchaseOrderId}/invoice`);
      })
      .catch((error) => {
        const message =
          error && error.response && error.response.data
            ? `Can't associate Invoice #${invoice.invoice_number} with Purchase Order #${purchaseOrderId}. ${error.response.data}`
            : `Can't associate Invoice #${invoice.invoice_number} with Purchase Order #${purchaseOrderId}.`;
        alertRef.current.sendAlert(message);
        console.log(error);
      });
  };
  return {
    fetchPurchaseOrderDetail: (id) => {
      dispatch(fetchPurchaseOrderDetail(id)).payload.then(
        (response) => {
          dispatch(fetchPurchaseOrderDetailSuccess(response.data));
        },
        (error) => {
          dispatch(fetchPurchaseOrderDetailFailure(error));
        }
      );
    },
    fetchVendors: (props) => {
      dispatch(fetchVendors()).payload.then(
        (response) => {
          dispatch(fetchVendorsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchVendorsFailure(error));
        }
      );
    },
    createInvoice: (data, props, isPurchaseOrder, alertRef) => {
      dispatch(createInvoice(data)).payload.then(
        (response) => {
          alertRef.current.sendAlert(`Invoice #${response.data.invoice_number} created successfully.`, "success");
          if (isPurchaseOrder) associateInvoice(props.match.params.id, response.data, props, alertRef);
          else finished(response.data, props);
          dispatch(createInvoiceSuccess(response.data));
        },
        (error) => {
          dispatch(createInvoiceFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReceiveContainer));
